<script>
  let { socket } = $props();
</script>

{socket.host}:{socket.port}
